import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Modal,
  Container,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AppDialogBox = ({ children, title, open, setOpen, size, disableBackdropClick = false }) => {
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        maxWidth={size ?? 'sm'}
        fullWidth
        disableBackdropClick={disableBackdropClick}
      >
        {title && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <DialogTitle>{title}</DialogTitle>
            <IconButton onClick={handleClose} sx={{ my: 'auto', mr: 1 }}>
              <CloseIcon />
            </IconButton>
          </Box>
        )}
        <Container>{children}</Container>
      </Dialog>
    </div>
  );
};

export default AppDialogBox;
